export default function BMIGauge({ bmi = 0, category = "" }) {
  const clamped = Math.max(10, Math.min(40, bmi || 0));
  // Map 10..40 -> 0..1
  const pct = (clamped - 10) / 30;
  const angle = -120 + pct * 240; // -120deg to 120deg
  const colorByCat = () => {
    if (!category) return "#047857";
    if (category.startsWith("Normal")) return "#059669";
    if (category.startsWith("Under")) return "#f59e0b";
    if (category.startsWith("Over")) return "#f59e0b";
    return "#dc2626";
  };
  const color = colorByCat();

  return (
    <div className="flex flex-col items-center" data-testid="bmi-gauge">
      <svg viewBox="0 0 200 140" className="w-full max-w-[280px]" aria-hidden>
        <defs>
          <linearGradient id="bmi-bg" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="50%" stopColor="#059669" />
            <stop offset="100%" stopColor="#dc2626" />
          </linearGradient>
        </defs>
        <path
          d="M20 120 A 80 80 0 0 1 180 120"
          fill="none"
          stroke="url(#bmi-bg)"
          strokeWidth="14"
          strokeLinecap="round"
          opacity="0.9"
        />
        {/* Needle */}
        <g
          style={{
            transform: `rotate(${angle}deg)`,
            transformOrigin: "100px 120px",
            transition: "transform 900ms cubic-bezier(.22,1,.36,1)",
          }}
        >
          <line x1="100" y1="120" x2="100" y2="50" stroke="#064e3b" strokeWidth="3" strokeLinecap="round" />
          <circle cx="100" cy="120" r="7" fill="#064e3b" />
        </g>
      </svg>
      <div className="text-center -mt-2">
        <div className="text-5xl font-display font-light text-emerald-950" data-testid="bmi-value">
          {bmi ? bmi.toFixed ? bmi.toFixed(1) : bmi : "--"}
        </div>
        <div
          className="mt-1 inline-block px-3 py-1 rounded-full text-xs uppercase tracking-[0.2em] font-semibold"
          style={{ color, backgroundColor: `${color}14` }}
          data-testid="bmi-category"
        >
          {category || "—"}
        </div>
      </div>
    </div>
  );
}
